// extracted by mini-css-extract-plugin
export default {"price":"taa-z","onSale":"uaa-z","msrpLabelPrice":"vaa-z","msrpLabel":"waa-z","originalPrice":"xaa-z"};